export class Room {
  code: string;
  description: string;
  maxNumberOfPeople: number;
  smoking: boolean;
  wheelchairAccessible: boolean;
  numRoomsAvailable: number;
  currencyCode: string;

  constructor(code?: string) {
    this.code = code;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/room/room.model.ts